import { createContext, useContext } from "react";

import { DEFAULT_EDIT_PLAYER_LABEL_API } from "../../hooks/use-edit-player-label-api";
import { PlayingSurfaceContextApi } from "./hooks";

export const PlayingSurfaceContext = createContext<PlayingSurfaceContextApi>({
  editPlayerLabelApi: DEFAULT_EDIT_PLAYER_LABEL_API,
  isEditable: false,
});

export const usePlayingSurfaceContext = () => useContext(PlayingSurfaceContext);
